export default __webpack_public_path__ + "static/history-of-hiv-section-hero-bd178b306c1ea8c6c482bc91900a9694.jpg";